import React from "react";
import "./Footer.scss";

import logo from "../../assets/logo.png";
import insta from "../../assets/icons/footer-Instagram.svg";
import tel from "../../assets/icons/footer-Telegram.svg";
import email from "../../assets/icons/footer-Linkedin.svg";

const Footer = ({ exchangeData }) => {
  return (
    <footer className="footer">
      <div className="footer-container wide-page-margin">
        <div className="social">
          <img src={logo} alt="Logo" className="logo w-[6.81rem]" />
          <div className="hidden-address hidden">
            آدرس: تهران ، میدان ونک ، خیابان ملاصدرا ، خیابان شیراز شمالی ، پلاک
            127
          </div>
          <div className="icons flex flex-col justify-start items-start">
            <a
            target="_blank" 
              href={`https://www.instagram.com/p/DaHxzN1DV1M/`}
              className="icon"
            >
              <img src={insta} alt="" />
              sarafiiex@
            </a>
            <a       target="_blank"  href={`https://t.me/${exchangeData?.telegram}`} className="icon">
              <img src={tel} alt="" />
              {exchangeData?.telegram}@
            </a>
            <a       target="_blank"  href={`mailto:${exchangeData?.email}`} className="icon">
              <img src={email} alt="" />
              {exchangeData?.email}
            </a>
          </div>
        </div>
        <div className="section">
          <h3>دسترسی سریع</h3>
          <ul>
            <li>
              <a className="" href="/">
                صفحه اصلی
              </a>
            </li>
            <li>
              <a className="" href="/about-us">
                درباره صرافی آی اکس
              </a>
            </li>
            <li>
              <a className="" href="/contact-us">
                تماس با ما
              </a>
            </li>
            <li>
              <a className="" href="/gallery">
                گالری آی اکس
              </a>
            </li>
          </ul>
        </div>
        <div className="section">
          <h3>راهنمای شما</h3>
          <ul>
            <li>
              <a className="" href="/terms-conditions">
                قوانین و مقررات
              </a>
            </li>
            <li>روزهای کاری: شنبه تا چهارشنبه</li>
            <li>ساعت کاری: 9 الی 15:30</li>
            <li>پنج شنبه ها: 9 الی 12 ظهر</li>
          </ul>
        </div>
        <div className="section">
          <h3>راه های ارتباط با ما</h3>
          <ul>
            <li>
              شماره تماس:
              <a
                className="mr-1"
                href={`tel:${exchangeData?.phone?.substring(0, 9)}`}
              >
                {exchangeData?.phone?.substring(4, 9)}-
                {exchangeData?.phone?.substring(0, 3)}
              </a>
            </li>
            {/* <li>
              شماره تماس:
              <a
                className="mr-1"
                href={`tel:${exchangeData?.phone?.substring(12)}`}
              >
                {exchangeData?.phone?.substring(24)}-
                {exchangeData?.phone?.substring(16, 23)}-
                {exchangeData?.phone?.substring(12, 15)}
              </a>
            </li> */}
            <li>
              فکس:
              <span className="ltr">
                {exchangeData?.fax && exchangeData?.fax.length > 3
                  ? `${exchangeData?.fax.substring(
                      4
                    )}-${exchangeData?.fax.substring(0, 3)}`
                  : exchangeData?.fax}
              </span>
            </li>
            <li>آدرس: {exchangeData?.address}</li>
          </ul>
        </div>
      </div>
      <div className="copyright">
        کلیه حقوق این وب سایت متعلق به شرکت محبوبه اشراقی و شرکا می‌باشد.
      </div>
    </footer>
  );
};

export default Footer;
